(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-articles"]) return;
  try {
    
  class AllArticlesList extends HTMLElement {
    connectedCallback() {
      this.perPage = parseInt(this.dataset.perPage, 10) || 16;
      this.items = [...this.querySelectorAll('.blog-posts__item')];
      this.button = this.querySelector('.blog-posts__load-more');
      this.visible = Math.min(this.perPage, this.items.length);

      if (this.button) {
        this.button.addEventListener('click', () => this.#loadMore());
      }
    }

    #loadMore() {
      const nextVisible = Math.min(this.visible + this.perPage, this.items.length);

      for (let i = this.visible; i < nextVisible; i++) {
        this.items[i].removeAttribute('hidden');
      }

      this.visible = nextVisible;

      if (this.visible >= this.items.length) {
        this.button.hidden = true;
      }
    }
  }

  if (!customElements.get('all-articles-list')) {
    customElements.define('all-articles-list', AllArticlesList);
  }

  } catch(e) { console.error(e); }
})();
})();
